<template>
		<form-dialog :title="$t('terminal.timeTask')" :dialogVisible="dialogVisible" @closeDialog="closeDialog" :isAppend="true" dWidth="600px">
			<div class="inner_content">
				<div class="rows">
					<span>{{ $t('terminal.operComman') }}:</span>
					<el-select v-model="sc_action" size="small">
						<el-option v-for="item in scOrderList" :key="item.value" :label="$t(item.label)" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="rows" v-if="this.sc_action == 2">
					<span>{{ $t('terminal.birght') }}:</span>
					<div style="display: flex; align-items: center">
						<div style="width: 200px">
							<el-slider v-model="sc_light"></el-slider>
						</div>
						<span style="margin-left: 10px">{{ sc_light }}</span>
					</div>
				</div>
				<div class="rows" v-if="this.sc_action == 3">
					<span>{{ $t('terminal.brigValue') }}:</span>
					<div style="display: flex; align-items: center">
						<div style="width: 200px">
							<el-slider v-model="sc_light"></el-slider>
						</div>
						<span style="margin-left: 10px">{{ sc_light }}</span>
					</div>
				</div>
				<div class="rows" v-if="this.sc_action == 6">
					<span>{{ $t('terminal.method') }}:</span>
					<div style="display: flex; align-items: center">
						<el-select v-model="sc_light" :placeholder="$t('terminal.selectTip1')" size="small">
							<el-option v-for="item in signal" :key="item.value" :label="$t(item.label)" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<!-- KPB板载电源 start -->
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<span>{{ $t('temporary1') }}:</span>
				</div>
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<el-checkbox-group v-model="kpbListSelect" size="small">
						<el-checkbox-button v-for="kpb in KPBpowers" :label="kpb" :key="kpb">{{ $t(kpb) }}
						</el-checkbox-button>
					</el-checkbox-group>
				</div>
				<!-- KPB板载电源 end -->
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<span>{{ $t('terminal.powerList') }}:</span>
				</div>
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<el-checkbox-group v-model="powerListSelect" size="small" @change="checkboxPowerChange">
						<el-checkbox-button v-for="power in powers" :label="power" :key="power">{{ $t(power) }}
						</el-checkbox-button>
					</el-checkbox-group>
				</div>
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<span>{{ $t('terminal.mulCard') }}:</span>
				</div>
				<div class="rows" v-if="this.sc_action == 7 || this.sc_action == 8">
					<el-checkbox-group v-model="cardListSelect" size="small" @change="checkboxCardChange">
						<el-checkbox-button v-for="card in cards" :label="card" :key="card">{{ $t(card) }}
						</el-checkbox-button>
					</el-checkbox-group>
				</div>
				<div class="rows">
					<span>{{ $t('terminal.excTime') }}:</span>
					<el-time-picker v-model="sc_time" value-format="HH:mm:ss" size="small"></el-time-picker>
				</div>
				<div class="rows">
					<span>{{ $t('terminal.dateOk') }}</span>
					<div style="dis_p">
						<el-radio v-model="sc_date_radio" label="1">{{ $t('terminal.noLimit') }}</el-radio>
						<el-radio v-model="sc_date_radio" label="2">{{ $t('terminal.speDate') }}</el-radio>
					</div>
				</div>
				<div class="rows" :style="{ 'justify-content': 'space-around' }">
					<div>
						<el-date-picker type="date" size="small" v-model="sc_date_start" :disabled="sc_date_radio == '1'"
							value-format="yyyy/MM/dd"></el-date-picker>
						<span>-</span>
						<el-date-picker type="date" size="small" v-model="sc_date_end" :disabled="sc_date_radio == '1'"
							value-format="yyyy/MM/dd"></el-date-picker>
					</div>
				</div>
				<div class="rows">
					<span>{{ $t('terminal.isWeekLi') }}</span>
					<div>
						<el-radio v-model="sc_week_radio" label="1">{{ $t('terminal.noLimit') }}</el-radio>
						<el-radio v-model="sc_week_radio" label="2">{{ $t('terminal.speWeek') }}</el-radio>
					</div>
				</div>
				<div class="rows" :style="{ 'justify-content': 'space-around' }">
					<el-checkbox-group v-model="weekListSelect" :disabled="sc_week_radio == 1" size="small"
						@change="checkboxWeeksChange">
						<el-checkbox-button v-for="week in weeks" :label="week" :key="week">{{ $t(week) }}
						</el-checkbox-button>
					</el-checkbox-group>
				</div>
				<div class="rows" :style="{ 'justify-content': 'space-around' }">
					<div>
						<el-button @click="innerCancel" round>{{ $t('terminal.cancel') }}</el-button>
						<el-button @click="innerConfirm" type="primary" round>{{ $t('terminal.confirm') }}</el-button>
					</div>
				</div>
			</div>
		</form-dialog>
</template>

<script>
const weekList = ["terminal.Sunday", "terminal.Monday", "terminal.Tuesday", "terminal.Wednesday", "terminal.Thursday", "terminal.Friday", "terminal.Saturday"];
const KPBpower = ['terminal.firstChannel'];
const powerList = ['terminal.firstChannel', 'terminal.secondChannel', 'terminal.thirdChannel'];
const cardList = ['terminal.firstChannel', 'terminal.secondChannel', 'terminal.thirdChannel', 'terminal.fourthChannel', 'terminal.fifthChannel', 'terminal.sixthChannel', 'terminal.seventhChannel', 'terminal.eighthChannel']
const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1;
const date = now.getDate();
const start_time =
	year +
	"/" +
	(month < 10 ? "0" + month : month) +
	"/" +
	(date < 10 ? "0" + date : date);
const hour = now.getHours();
const minutes = now.getMinutes();
const seconds = now.getSeconds();
const nowtime = hour + ":" + minutes + ":" + seconds;
const end_time = start_time;
let weekObj = {
	"terminal.Sunday": Math.pow(2, 0),
	"terminal.Monday": Math.pow(2, 1),
	"terminal.Tuesday": Math.pow(2, 2),
	"terminal.Wednesday": Math.pow(2, 3),
	"terminal.Thursday": Math.pow(2, 4),
	"terminal.Friday": Math.pow(2, 5),
	"terminal.Saturday": Math.pow(2, 6),
};
let cardObj = {
	'terminal.firstChannel': Math.pow(2, 0),
	'terminal.secondChannel': Math.pow(2, 1),
	'terminal.thirdChannel': Math.pow(2, 2),
	'terminal.fourthChannel': Math.pow(2, 3),
	'terminal.fifthChannel': Math.pow(2, 4),
	'terminal.sixthChannel': Math.pow(2, 5),
	'terminal.seventhChannel': Math.pow(2, 6),
	'terminal.eighthChannel': Math.pow(2, 7),
}
let powerObj = {
	'terminal.firstChannel': Math.pow(2, 8),
	'terminal.secondChannel': Math.pow(2, 9),
	'terminal.thirdChannel': Math.pow(2, 10),
};

let kpbObj = {
	'terminal.firstChannel': Math.pow(2, 11),
};
import FormDialog from "@/components/basics/FormDialogConfirm";
import {
	daysWeek
} from "@/assets/scripts/publicFunction.js";
// this.$emit('closeSchedule', 'cancel') cancel:取消，否则返回数据
export default {
	name: 'Schedule',
	props: {
		ADDEDIT: { //编辑或者添加
			type: String,
			default: 'ADD'
		},
		schduleDialog: { //弹窗显示
			type: Boolean,
			default: false
		},
		value: { //数据，编辑时必传
			type: Object
		}
	},
	components: {
		FormDialog
	},
	data() {
		return {
			dialogVisible: false,
			sc_action: 2,
			scOrderList: [{
				value: 2,
				label: "terminal.conBright",
			},
			{
				value: 3,
				label: "terminal.conVoice",
			},
			{
				value: 4,
				label: "terminal.action9",
			},
			{
				value: 5,
				label: "terminal.action10",
			},
			{
				value: 6,
				label: "terminal.action6"
			},
			{
				value: 7,
				label: 'terminal.action7'
			},
			{
				value: 8,
				label: 'terminal.action8'
			}
			],
			signal: [{
				value: 1,
				label: 'terminal.acVa1'
			}, {
				value: 2,
				label: 'terminal.acVa2'
			}, {
				value: 3,
				label: 'terminal.acVa3'
			}],
			sc_light: 50,
			sc_date_radio: "1",
			sc_week_radio: "1",
			sc_time: nowtime,
			sc_date_start: start_time,
			sc_date_end: end_time,
			validWeek: 0,
			weeks: weekList,
			weekListSelect: [],
			kpbListSelect: [],
			powerListSelect: [],
			cardListSelect: [],
			KPBpowers: KPBpower,
			powers: powerList,
			cards: cardList,
			formValue: {}
		}
	},
	methods: {
		closeDialog() {
			this.$emit('closeSchedule', 'cancel')
			this.sc_action = 2;
			this.sc_light = 50;
			this.kpbListSelect = [];
			this.powerListSelect = [];
			this.cardListSelect = [];
			this.sc_time = nowtime;
			this.sc_date_radio = '1';
			this.sc_week_radio = '1';
			this.sc_date_start = start_time;
			this.sc_date_end = end_time;
			this.validWeek = 0;
			this.weekListSelect = [];
			this.dialogVisible = false;
		},
		checkboxPowerChange() {
			console.log('power', this.powerListSelect);
		},
		checkboxCardChange() {
		},
		checkboxWeeksChange() {
			let weekB = 0;
			this.weekListSelect.forEach((week) => {
				weekB += weekObj[week];
			});
			this.validWeek = weekB.toString(2);
		},
		innerConfirm() {
			this.formValue = {
				'action': this.sc_action,
				'value': this.sc_light,
				'startTime': this.sc_time,
				'isDateLimit': this.sc_date_radio === "1" ? false : true,
				'isWeekLimit': this.sc_week_radio === "1" ? false : true,
				'dateStart': this.sc_date_start,
				'dateEnd': this.sc_date_end,
				'validWeek': this.validWeek,
				'weekShow': daysWeek(parseInt(this.validWeek, 2))
			}
			// console.log('确定',)
			if (this.sc_action == '7' || this.sc_action == '8') {
				let value = 0;
				this.powerListSelect.forEach((ele) => {
					value += powerObj[ele];
				});
				this.cardListSelect.forEach(ele => {
					value += cardObj[ele];
				})
				this.kpbListSelect.forEach(ele => {
					value += kpbObj[ele];
				})
				let status = value.toString(2);
				while (status.length < 12) {
					status = "0" + status;
				}
				this.formValue.value = parseInt(status, 2);
			}
			// console.log(this.formValue);
			this.$emit('closeSchedule', this.formValue);
		},
		innerCancel() {
			this.$emit('closeSchedule', 'cancel')
		}
	},
	watch: {
		schduleDialog() {
			this.dialogVisible = this.schduleDialog;
			this.sc_time = nowtime;
			this.sc_date_start = start_time;
			this.sc_date_end = end_time;
		},
		ADDEDIT() {
			if (this.ADDEDIT === 'EDIT') {
				this.sc_action = this.value.action;
				this.sc_time = this.value.startTime;
				this.sc_date_radio = this.value.isDateLimit == false ? "1" : "2";
				this.sc_week_radio = this.value.isWeekLimit == false ? "1" : "2";
				this.sc_date_end = this.value.dateEnd;
				this.sc_date_start = this.value.dateStart;
				this.sc_light = this.value.value;
				this.validWeek = this.value.validWeek.toString(2);
				let validWeek = this.validWeek;
				let thisWeeks = ["terminal.Saturday", "terminal.Friday", "terminal.Thursday", "terminal.Wednesday", "terminal.Tuesday", "terminal.Monday", "terminal.Sunday"];
				let kpb = ['terminal.firstChannel'];
				let power = ['terminal.thirdChannel', 'terminal.secondChannel', 'terminal.firstChannel'];
				let card = ['terminal.eighthChannel', 'terminal.seventhChannel', 'terminal.sixthChannel', 'terminal.fifthChannel', 'terminal.fourthChannel', 'terminal.thirdChannel', 'terminal.secondChannel', 'terminal.firstChannel'];
				let KPBpowers = [];
				let powers = [];
				let cards = [];
				let weeks = [];
				let weekArr = (validWeek + "").split("");
				let valueArr = this.value.value.toString(2).split('');
				while (weekArr.length <= 7) {
					weekArr.unshift("0");
				}
				while (valueArr.length < 12) {
					valueArr.unshift('0');
				}

				let kpbValue = valueArr.slice(0, 1);
				let powerValue = valueArr.slice(1, 4);
				let cardValue = valueArr.slice(4, valueArr.length);

				weekArr.forEach((item, index) => {
					if (item === "1") {
						weeks.push(thisWeeks[index - 1]);
					}
				});

				kpbValue.forEach((item, index) => {
					if (item === "1") {
						KPBpowers.push(kpb[index]);
					}
				})
				powerValue.forEach((item, index) => {
					if (item === "1") {
						powers.push(power[index]);
					}
				})
				cardValue.forEach((item, index) => {
					if (item === "1") {
						cards.push(card[index]);
					}
				})
				this.weekListSelect = weeks;
				this.kpbListSelect = KPBpowers;
				this.powerListSelect = powers;
				this.cardListSelect = cards;
				// switch (this.sc_action){
				// 	case 7:
				// 	case 8:
				// }

			}
		},
		sc_action() {
			switch (this.sc_action) {
				case 6:
					this.sc_light = 1;
					break;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
// .schedule {
// 	width: 100%;
// 	height: 100%;
// }

.inner_content {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;

	.rows {
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
		padding-left: 10px;
		padding-right: 10px;
		margin-top: 10px;
	}
}
</style>
